// @flow
import * as React from 'react'
import moment from 'moment-timezone'
import type { Gathering, School } from 'types'
import { schoolVanityUrl } from 'urls'
import { BoldText, P, Subtitle } from 'ui/Typography'
import AddressView from 'ui/Address'
import RailSection from '../shared//RailSection'
import GatheringPageShareButtons from './ShareButtons'
import Link from 'ui/Link'

type Props = {
  gathering: Gathering,
  school: School,
}

export default class GatheringPageInfo extends React.Component<Props> {
  render = () => {
    return (
      <React.Fragment>
        <RailSection title="Location">
          <P>
            <BoldText>{this.props.gathering.location}</BoldText>
            <br />
            <AddressView address={this.props.gathering.address} />
          </P>
          <P>
            <Subtitle>
              <Link href={schoolVanityUrl(this.props.school)}>View Our Homepage</Link>
            </Subtitle>
          </P>
        </RailSection>

        <RailSection title="Date and Time">
          <P>
            <BoldText>{this.formatBeginsAt('dddd MMM DD, YYYY')}</BoldText>
            <br />
            {this.formatBeginsAt('h:mma')}-{this.formatEndsAt('h:mma')}
          </P>
        </RailSection>

        <RailSection title="Share">
          <GatheringPageShareButtons gathering={this.props.gathering} />
        </RailSection>
      </React.Fragment>
    )
  }

  formatBeginsAt = (format: string): string => {
    return moment(this.props.gathering.beginsAt).tz(this.props.school.timezone).format(format)
  }

  formatEndsAt = (format: string): string => {
    return moment(this.props.gathering.endsAt).tz(this.props.school.timezone).format(format)
  }
}
